import http from "../http-common";

class AnalyticsDataService {
  getGraph(prompt: any) {
    return http.get(`crm/analytics/graph?prompt=${prompt}`);
  }

  getExpertProfileVisitCount(startDate: string, endDate: string) {
    return http.get(
      `crm/analytics/experts/visit-count?startDate=${startDate}&endDate=${endDate}`
    );
  }

  getExpertBookingsCount(startDate: string, endDate: string) {
    return http.get(
      `crm/analytics/experts/bookings-count?startDate=${startDate}&endDate=${endDate}`
    );
  }
  getExpertSlotCheckedCount(startDate: string, endDate: string) {
    return http.get(
      `crm/analytics/experts/slot-checked-count?startDate=${startDate}&endDate=${endDate}`
    );
  }

  getExpertPeakHoursCount(startDate: string, endDate: string) {
    return http.get(
      `crm/analytics/experts/peak-hours-count?startDate=${startDate}&endDate=${endDate}`
    );
  }

  getExpertSubsLeftCount() {
    return http.get(`crm/analytics/experts/subs-left-count`);
  }

  getEhcSuggestedExpertCount(startDate: string, endDate: string) {
    return http.get(
      `crm/analytics/experts/suggested-count?startDate=${startDate}&endDate=${endDate}`
    );
  }

  getContactStatusCount(
    startDate: string,
    endDate: string,
    leadSource: string,
    platforms: any[]
  ) {
    return http.post(
      `crm/analytics/status-counts?fromDate=${startDate}&toDate=${endDate}&leadSource=${leadSource}`,
      { platforms }
    );
  }
  getAssessmentCount(startDate: string, endDate: string, platforms: any[]) {
    return http.post(
      `crm/analytics/assessment-counts?fromDate=${startDate}&toDate=${endDate}`,
      { platforms }
    );
  }

  getBookingCount(startDate: string, endDate: string) {
    return http.post(
      `crm/analytics/bookings-count?fromDate=${startDate}&toDate=${endDate}`
    );
  }

  getEhcCount(startDate: string, endDate: string, platforms: any[]) {
    return http.post(
      `crm/analytics/ehc-counts?fromDate=${startDate}&toDate=${endDate}`,
      { platforms }
    );
  }

  getBookingMonthlyData(type: any) {
    return http.get(
      `https://api.manoshala.com/bookings/count/monthlydata?type=${type}`
    );
  }

  getUserMonthlyData(type: any) {
    return http.get(
      `https://api.manoshala.com/users/count/monthlydata?type=${type}`
    );
  }
}
export default new AnalyticsDataService();
